module.exports = __webpack_public_path__ + "static/media/zero_percent.a3c72439.png";